import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * PRD § Public Browse Flow: every catalog screen has breadcrumbs.
 * Renders as a horizontal list with hairline separators, muted text,
 * and an indigo accent on the current page.
 */
export default function Breadcrumbs({ items }) {
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="flex flex-wrap items-center gap-1 text-meta text-ink-muted"
    >
      {items.map((it, i) => {
        const last = i === items.length - 1;
        // Breadcrumb entries have no server-issued ID; the (to || label)
        // pair is unique within a single breadcrumb chain (a chain never
        // revisits the same route twice), and pairing it with the index
        // keeps the key stable across renders even when a chain has two
        // trailing crumbs without a `to`.
        const key = `${it.to || it.label || ""}-${i}`;
        return (
          <React.Fragment key={key}>
            {i > 0 && (
              <ChevronRight size={14} className="text-ink-chip" aria-hidden />
            )}
            {last || !it.to ? (
              <span
                className={last ? "text-ink-text" : "text-ink-muted"}
                aria-current={last ? "page" : undefined}
                data-testid={`breadcrumb-${i}`}
              >
                {it.label}
              </span>
            ) : (
              <Link
                to={it.to}
                data-testid={`breadcrumb-link-${i}`}
                className="text-ink-muted hover:text-ink-text transition-colors duration-cc ease-cc-ease"
              >
                {it.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
